import { IApplicationState } from '../../types/redux';

export const selectProjectId = (state: IApplicationState) => {
  return state.projectData.project.id;
};
